module.exports = __webpack_public_path__ + "img/orange_location.d9cefc17.svg";